module.exports = __webpack_public_path__ + "static/media/apple-icon-114x114.516e5f02.png";